const violet300Color = '#8B98C1';

export default violet300Color;
